import {NaoAutorizadoModule} from '~pages/nao-autorizado/nao-autorizado.module';
import {BrowserModule} from '@angular/platform-browser';
import {APP_INITIALIZER, NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {VisualModule} from '~shared/material/visual.module';
import {CoreModule} from '~core/core.module';
import {ComponentsModule} from '~shared/components/components.module';
import {PrintLayoutComponent} from '~shared/refatorar/print-layout/print-layout.component';
import {InvoiceComponent} from '~shared/refatorar/invoice/invoice.component';
import {PortalModule} from '@angular/cdk/portal';
import {InvoiceExampleComponent} from '~shared/refatorar/invoice/invoice-example.component';
import {ReactiveFormsModule} from '@angular/forms';
import {MenuComponent} from '~shared/menu/menu.component';
import {SettingsMenuComponent} from '~shared/settings-menu/settings-menu.component';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import {environment} from '~env/environment';
import {MultiTranslateHttpLoader} from 'ngx-translate-multi-http-loader';
import {assetUrl} from 'src/single-spa/asset-url';
import { ThemingService } from './theming.service';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { LucideAngularModule, MessageSquareText, TriangleAlert } from 'lucide-angular';

const { defaultLanguage } = environment.adds;
const HttpLoaderFactory = (http: HttpClient) => new MultiTranslateHttpLoader(http, [
  {prefix: assetUrl('/i18n/'), suffix: '.json'},
  {prefix: assetUrl('./i18n/alerts-management/'), suffix: '.json'},
  {prefix: assetUrl('./i18n/chat/'), suffix: '.json'},
  {prefix: assetUrl('./i18n/configurations/'), suffix: '.json'},
  {prefix: assetUrl('./i18n/dashboard/'), suffix: '.json'},
  {prefix: assetUrl('./i18n/filter/'), suffix: '.json'},
  { prefix: assetUrl('./i18n/grid/'), suffix: '.json' },
  { prefix: assetUrl('./i18n/config-grupo-usuario/'), suffix: '.json' },
  {prefix: assetUrl('./i18n/header-gadget/'), suffix: '.json'},
  {prefix: assetUrl('./i18n/import/'), suffix: '.json'},
  {prefix: assetUrl('./i18n/login/'), suffix: '.json'},
  {prefix: assetUrl('./i18n/map/'), suffix: '.json'},
  {prefix: assetUrl('./i18n/map-gadget/'), suffix: '.json'},
  {prefix: assetUrl('./i18n/reprogramming/'), suffix: '.json'},
  {prefix: assetUrl('./i18n/route-card/'), suffix: '.json'},
  {prefix: assetUrl('./i18n/route-details/'), suffix: '.json'},
  {prefix: assetUrl('./i18n/route-history/'), suffix: '.json'},
  {prefix: assetUrl('./i18n/route-report/'), suffix: '.json'},
  {prefix: assetUrl('./i18n/alerts-management/'), suffix: '.json'},
  {prefix: assetUrl('./i18n/visits-management/'), suffix: '.json'},
  {prefix: assetUrl('./i18n/configurations/'), suffix: '.json'},
  {prefix: assetUrl('./i18n/import/'), suffix: '.json'},
  {prefix: assetUrl('./i18n/chat/'), suffix: '.json'},
  {prefix: assetUrl('./i18n/security/'), suffix: '.json'},
  {prefix: assetUrl('./i18n/services/'), suffix: '.json'},
  {prefix: assetUrl('./i18n/visits-management/'), suffix: '.json'},
  {prefix: assetUrl('./i18n/timeline/'), suffix: '.json'},
  {prefix: assetUrl('./i18n/portal-cliente/'), suffix: '.json'},
]);

@NgModule({
  declarations: [
    MenuComponent,
    SettingsMenuComponent,
    AppComponent,
    PrintLayoutComponent,
    InvoiceComponent,
    InvoiceExampleComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    CoreModule,
    VisualModule,
    ComponentsModule,
    PortalModule,
    ReactiveFormsModule,
    NaoAutorizadoModule,
    LucideAngularModule.pick({ TriangleAlert, MessageSquareText }),
    TranslateModule.forRoot({
      defaultLanguage,
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  bootstrap: [AppComponent],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (service: ThemingService) => () => service.initialize(),
      deps: [ThemingService],
      multi: true,
    },
  ],
})
export class AppModule {
  constructor(matIconRegistry: MatIconRegistry, domSanitizer: DomSanitizer) {
    matIconRegistry.addSvgIcon(
      'vector_map',
      domSanitizer.bypassSecurityTrustResourceUrl('assets/material/vector_map.svg')
    );
    matIconRegistry.addSvgIcon(
      'dollar_note',
      domSanitizer.bypassSecurityTrustResourceUrl('assets/material/dollar_note.svg')
    );
    matIconRegistry.addSvgIcon(
      'dollar_note_white',
      domSanitizer.bypassSecurityTrustResourceUrl('assets/material/dollar_note_white.svg')
    );
  }
}
